import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getQuestionPapers } from "../../../../configs/WebService";
import { apiKeyHeader } from "../../../../configs/ApiKeys";
import axios from "axios";
export const fetchCategoryBasedPapers = createAsyncThunk(
  "allPapers/fetchCategoryBasedPapers",
  async ({ type, userId }, { rejectWithValue }) => {
    try {
      const resp = await axios.get(`${getQuestionPapers}?type=${type}&userId=${userId}`, { headers: apiKeyHeader() });
      const data = resp?.data;
      if (!resp || resp.status < 200 || resp.status >= 300) {
        return rejectWithValue(data?.message || "Failed to fetch events");
      }
      return data;
    } catch (error) {
      console.error(error.message || "Failed to fetch events");
      return rejectWithValue(error.message);
    }
  },
);

const initialState = {
  status: "idle",
  error: null,
  categoryBasedData: [],
  userName: "",
  createdAt: null,
  class_id: "",
  subject_id: "",
};
const allPaperSlice = createSlice({
  name: "allPapers",
  initialState: initialState,
  reducers: {
    setState: (state, action) => {
      const { key, value } = action.payload;
      state[key] = value;
    },
    resetState: (state) => {
      state.status = "idle";
      state.error = null;
      state.categoryBasedData = [];
      state.userName = "";
      state.createdAt = null;
      state.class_id = "";
      state.subject_id = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategoryBasedPapers.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchCategoryBasedPapers.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.categoryBasedData = action.payload;
      })
      .addCase(fetchCategoryBasedPapers.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});
export const { setState, resetState } = allPaperSlice.actions;
export default allPaperSlice.reducer;
